export default "__VITE_ASSET__Dl_Gp2eh__"